import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// 원본 console 함수들을 강제로 저장
// const originalLog = window.console.log;
// const originalInfo = window.console.info;
// const originalWarn = window.console.warn;
// const originalError = window.console.error;

// console 객체 자체를 재정의
// window.console = {
//   ...window.console,
//   log: originalLog.bind(window.console),
//   info: originalInfo.bind(window.console),
//   warn: originalWarn.bind(window.console),
//   error: originalError.bind(window.console)
// };

console.log("🔥🔥🔥 React 앱 시작! - console 강제 복구됨");
console.log("🔥 NODE_ENV:", process.env.NODE_ENV);
console.log("🔥 현재 시간:", new Date().toISOString());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // StrictMode 임시 비활성화 - 개발 환경에서만 영향
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
